import DialogCloseButton from '@/components/dialog/DialogCloseButton'
import { useTranslator } from '@/hooks'
import { Dialog, DialogActions, DialogContent, Typography } from '@mui/material'

import { Button } from '@/@core/components/mui/Button'

interface IExistLogindialog {
  open: boolean
  setOpen: (open: boolean) => void
}

export function ExistLogindialog({ open, setOpen }: IExistLogindialog) {
  const { __ } = useTranslator()
  // const n = useNotification()

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='sm'
      scroll='body'
      fullWidth
      closeAfterTransition={false}
      sx={{
        '& .MuiDialog-paper': { overflow: 'visible', maxWidth: '800px' }
      }}
    >
      <DialogCloseButton onClick={handleClose} sx={{ position: 'absolute', right: 0, top: 0, zIndex: 1302 }}>
        <i className='tabler-x' />
      </DialogCloseButton>

      <DialogContent>
        <Typography
          variant='h4'
          className='md:text-[24px] text-[24px] leading-[38px] font-bold mt-8 text-[#2F2B3DE5] text-center'
        >
          {__('This Account is Already Logged In Another Place')}
        </Typography>
        <Typography className='text-[15px] leading-[22px] text-[#2F2B3DB2] text-center'>
          {__('It looks like you are already logged in another place. Do you still want to log in?')}
        </Typography>
        <div className='text-center'>
          <img
            alt='error-404-illustration'
            src='/images/illustrations/auth/exist.png'
            className='object-cover bs-[400px] md:bs-[450px] lg:bs-[500px] mbs-10 md:mbs-14 lg:mbs-20'
          />
        </div>
      </DialogContent>

      <DialogActions className='px-[20px] sm:px-[24px] text-center justify-center gap-2'>
        <Button
          variant='contained'
          onClick={handleClose}
          sx={{ backgroundColor: '#3551F2', height: 38, color: '#fff' }}
        >
          {__('continue')}
        </Button>
        <Button
          variant='contained'
          onClick={handleClose}
          sx={{ backgroundColor: '#6F83F629', height: 38, color: '#6F83F6' }}
        >
          {__('Cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
